jQuery(document).ready(function ($) {
    // Elements class names
    const ELEMENTS = {
        CONTENT: 'content',
        SECTION: 'section',
        NAVBAR : 'site-header',
        BLOCK_VIDEO: 'block-video',
        BLOCK_VIDEO_VIDEO: 'block-video__video',
        BLOCK_VIDEO_ARROW: 'block-video__arrow'
    }
    let videoFirstSection = false;

    // Early exit if no video block on the page
    if ($(`.${ELEMENTS.BLOCK_VIDEO}`).length === 0) {
        return;
    }

    // --------------------------------------------
    // Functions
    // --------------------------------------------
    /**
     * Resize video to accommodate the nav bar height
     */
    const resizeVideoForNav = () => {
        const navBar = $(`.${ELEMENTS.NAVBAR}`);

        // Early exit if no nav bar
        if (navBar.length === 0) {
            return;
        }

        $(`.${ELEMENTS.BLOCK_VIDEO_VIDEO}`).outerHeight(`calc(100vh - ${navBar.outerHeight()}px)`);
    }

    /**
     * Scroll to next section after the video block
     */
    const scrollToNextSection = () => {
        const nextSection = $(`.${ELEMENTS.BLOCK_VIDEO}`)
            .nextAll(ELEMENTS.SECTION)
            .first()
            .get(0);
        const navBar = $(`.${ELEMENTS.NAVBAR}`);

        // Video block does not have a section after it.
        if (nextSection.length === 0 || navBar.length === 0) {
            return;
        }

        // Calculate how far down the page the next sections is, including the sticky header
        const offset = nextSection.getBoundingClientRect().top + window.scrollY - navBar.outerHeight();

        window.scrollTo({
            top: offset,
            behavior: 'smooth'
        });
    }
    // --------------------------------------------
    // End Functions
    // --------------------------------------------

    // --------------------------------------------
    // Event Listeners
    // --------------------------------------------
    const content = $(`#${ELEMENTS.CONTENT}`);

    // Check if video is the first block on the page, if so adjust video height to accommodate the nav height
    if (content) {
        videoFirstSection = content
            .children()
            .first()
            .hasClass(ELEMENTS.BLOCK_VIDEO);
    }

    // Onload event
    if (videoFirstSection) {
        resizeVideoForNav();

        // On resize
        $(window).on('resize', function() {
            resizeVideoForNav();
        });
    }

    // Arrow event listener
    const arrowEventListeners = () => {
        const arrow = $(`.${ELEMENTS.BLOCK_VIDEO_ARROW}`);

        // Early exit, check arrow exists
        if (arrow.length === 0) {
            return;
        }

        arrow.on('click', function() {
            scrollToNextSection();
        });
    }

    arrowEventListeners();
    // --------------------------------------------
    // End Event Listeners
    // --------------------------------------------
});